import { render, staticRenderFns } from "./AssessmentFarmerResponses.vue?vue&type=template&id=461c273c&scoped=true"
import script from "./AssessmentFarmerResponses.vue?vue&type=script&lang=js"
export * from "./AssessmentFarmerResponses.vue?vue&type=script&lang=js"
import style0 from "./AssessmentFarmerResponses.vue?vue&type=style&index=0&id=461c273c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c273c",
  null
  
)

export default component.exports